import React from 'react';
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from 'react-image-gallery';
import { ExteriorImages } from '../images/ExteriorImages'
import { ApartmentImages } from '../images/ApartmentImages';
import { StudioImages } from '../images/StudioImages';
import { Studio2Images } from '../images/Studio2Images';
import Flags from 'country-flag-icons/react/3x2'
import { faParking, faWifi, faDog, faUser, faBicycle, faPhone, faEnvelope, faMapMarkedAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import { faClock as farClock } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import DiscgolfPic from '../images/disc.jpg';
import '../css/Footer.css';

const useStyles = makeStyles({
    table: {
        minWidth: 300,
    },
    TableCell: {
        fontSize: 20,
        // color: "white"
        padding: 20
    },
    TableRow: {
        backgroundColor: "#d1d1d1",
    }
});

function HomeEN() {

    const classes = useStyles();

    return (
        <div className="homeBody">
            <div className="flags">
                <NavLink exact to={"/"} activeClassName="active" className="option">
                    <Flags.EE title="Estonia" className="flag" />
                </NavLink>
                <NavLink exact to={"/en"} activeClassName="active" className="option">
                    <Flags.GB title="English" className="flag" />
                </NavLink>
                <NavLink exact to={"/ru"} activeClassName="active" className="option">
                    <Flags.RU title="Russia" className="flag" />
                </NavLink>
            </div>

            <div className="mainInfo">
                <p className="LPI">&nbsp;<FontAwesomeIcon icon={faParking} className="parkingSign sign" />&nbsp;&nbsp; FREE PARKING</p>
                <p className="LPI"><FontAwesomeIcon icon={faWifi} className="wifiSign sign" />&nbsp; FREE WIFI</p>
                <p className="LPI"><FontAwesomeIcon icon={faDog} className="dogSign sign" /> &nbsp;PETS ALLOWED </p>
                <p className="LPI"><FontAwesomeIcon icon={faBicycle} className="bicycleSign sign" /> &nbsp;BICYCLE RENTAL</p>
            </div>




            <div className="landingPage">
                <div className="title">
                    <h1>Laheveere Villa</h1>
                </div>
            </div>

            <div className="afterScroll">
                <div className="first">

                    <div className="description">
                        <p><span>Laheveere Villa</span> is located in Võru County, Värska.
                            We have been operating as an accommodation since the summer of 2021.
                            Maximum capacity is 25 people.
                            There are total of 3 large two-bedroom apartments and 2 studios with a terrace.
                            Each apartment has a kitchenette with everything you need for cooking.
                            There is also a barbecue in the garden and a large backyard where you can play disc golf.</p>
                        <div className="kartul">
                            <img src={DiscgolfPic} alt="Discgolf" />
                            <div className="kartul23">
                                <p><FontAwesomeIcon icon={faClock} /> Check-in: 15:00 - 22:00</p>
                                <p><FontAwesomeIcon icon={farClock} /> Check-out: ......... - 12:00</p>
                            </div>
                        </div>

                    </div>
                    <div className="exteriorImages">
                        <div className="apartmentImages">
                            <ImageGallery showPlayButton={false} items={ExteriorImages} />
                        </div>
                    </div>
                </div>


                <div className="apartments">

                    <div className="title2">
                        <h1>Apartments</h1>
                    </div>

                    <div className="apartmentDiv">
                        <div className="images">
                            <ImageGallery showPlayButton={false} showThumbnails={false} showBullets items={ApartmentImages} />
                        </div>
                        <div className="apartmentInfo">
                            <h2>Two bedroom apartment</h2>
                            <h3>1 - 6 people (70m<sup>2</sup>)</h3>
                            <div className="apartContent">
                                <div className="apartInfo">
                                    <h5>Beds:</h5>
                                    <p>1 x king size bed</p>
                                    <p>2 x single bed</p>
                                    <p>1 x sofa bed (up to 2 people)</p>
                                </div>
                                <div className="apartPrices">
                                    <h5>Daily rates*:</h5>
                                    <h6>With own bed linen 5€ cheaper per person!</h6>

                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow className={classes.TableRow} >
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /></TableCell>
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /> <FontAwesomeIcon icon={faUser} /></TableCell>
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /> <FontAwesomeIcon icon={faUser} /> <FontAwesomeIcon icon={faUser} /></TableCell>
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /> <b> x 4</b></TableCell>
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /> <b> x 5</b></TableCell>
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /> <b> x 6</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow className={classes.TableRow}>
                                                <TableCell className={classes.TableCell} align="center">80 €</TableCell>
                                                <TableCell className={classes.TableCell} align="center">86 €</TableCell>
                                                <TableCell className={classes.TableCell} align="center">92 €</TableCell>
                                                <TableCell className={classes.TableCell} align="center">98 €</TableCell>
                                                <TableCell className={classes.TableCell} align="center">104 €</TableCell>
                                                <TableCell className={classes.TableCell} align="center">110 €</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <br />
                                    <p>*If the stay is longer than 3 days, the price is negotiable</p>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="apartmentDiv">
                        <div className="images">
                            <ImageGallery showPlayButton={false} showThumbnails={false} showBullets items={StudioImages} />
                        </div>
                        <div className="studioInfo">
                            <h2>Apartment with terrace I</h2>
                            <h3>1 - 3 people (35m<sup>2</sup>)</h3>
                            <h4>3rd floor  (accessible only by stairs)</h4>
                            <div className="apartContent">
                                <div className="apartInfo">
                                    <h5>Beds:</h5>
                                    <p>1 x single bed</p>
                                    <p>1 x sofa bed (up to 2 people)</p>
                                </div>
                                <div className="apartPrices">
                                    <h5>Daily rates*:</h5>
                                    <h6>With own bed linen 5€ cheaper per person!</h6>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow className={classes.TableRow} >
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /></TableCell>
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /> <FontAwesomeIcon icon={faUser} /></TableCell>
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /> <FontAwesomeIcon icon={faUser} /> <FontAwesomeIcon icon={faUser} /></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow className={classes.TableRow}>
                                                <TableCell className={classes.TableCell} align="center">66 €</TableCell>
                                                <TableCell className={classes.TableCell} align="center">74 €</TableCell>
                                                <TableCell className={classes.TableCell} align="center">82 €</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <br />
                                    <p>*If the stay is longer than 3 days, the price is negotiable</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="apartmentDiv">
                        <div className="images">
                            <ImageGallery showPlayButton={false} showThumbnails={false} showBullets items={Studio2Images} />
                        </div>
                        <div className="studioInfo">
                            <h2>Apartment with terrace II</h2>
                            <h3>1 - 2 people (35m<sup>2</sup>)</h3>
                            <h4>3rd floor (accessible only by stairs)</h4>
                            <div className="apartContent">
                                <div className="apartInfo">
                                    <h5>Beds:</h5>
                                    <p>1 x sofa bed (up to 2 people)</p>
                                </div>
                                <div className="apartPrices">
                                    <h5>Daily rates*:</h5>
                                    <h6>With own bed linen 5€ cheaper per person!</h6>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow className={classes.TableRow} >
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /></TableCell>
                                                <TableCell className={classes.TableCell} align="center"><FontAwesomeIcon icon={faUser} /> <FontAwesomeIcon icon={faUser} /></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow className={classes.TableRow}>
                                                <TableCell className={classes.TableCell} align="center">64 €</TableCell>
                                                <TableCell className={classes.TableCell} align="center">72 €</TableCell>

                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <br />
                                    <p>*If the stay is longer than 3 days, the price is negotiable</p>
                                </div>

                            </div>

                        </div>
                    </div>




                </div>

            </div >
            <div className="footer">
                <div className="content">
                    <div className="info">
                        <h1>Contact</h1>

                        <p><FontAwesomeIcon icon={faPhone} /> +372 5345 1111</p>
                        <p><FontAwesomeIcon icon={faEnvelope} /> info@nigola.ee</p>
                        <p><FontAwesomeIcon icon={faMapMarkedAlt} /> P. Haavaoksa 6, Värska, Võru county</p>
                    </div>
                    <div className="map2">
                        <div className="map">
                            <iframe title="Google Maps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2116.5402941087755!2d27.626663115494896!3d57.961744026949255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46eabfa2223b7989%3A0xcbd27ae86be1e452!2sP.%20Haavaoksa%206%2C%20V%C3%A4rska%2C%2064001%20V%C3%B5ru%!5e0!3m2!1set!2see!4v1621436667304!5m2!1set!2see"></iframe>
                        </div>
                    </div>
                    <div className="copyright">
                        <p>© 2021 Laheveere Villa</p>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default HomeEN;